export const SITE_CONFIG = {
  name: "Township",
  description: "Digital product agency that helps ambitious teams",
  url: "https://township.agency",
} as const;

export const SITE_TAGLINE =
  "We’re a team of designers and software engineers that help teams at the moments that matter most. We help when products, websites, or platforms need to grow up or come to life.";
